module.exports = __webpack_public_path__ + "img/icon (8).2c2df510.png";